import React from 'react'

import { Body3, Heading4, Space, Strong } from '@gousto-internal/citrus-react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'

import { SectionPanel } from 'routes/Menu/components/Detail/SectionPanel'
import { sanitize } from 'utils/sanitizer'

import { Allergens } from './Allergens'

type RecipeAllergensProps = {
  ingredients?: RecipeQueryResponse['ingredients']
  allergens?: RecipeQueryResponse['allergens']
  loading: boolean
}

export const RecipeAllergens = ({ ingredients, allergens, loading }: RecipeAllergensProps) => {
  if (loading || !ingredients?.included?.length) {
    return null
  }

  return (
    <SectionPanel data-testing="recipeDetailsAllergenList">
      <div>
        <Heading4>Ingredients contain</Heading4>
        <Space size={4} />
        {ingredients.included.map((ingredient) => (
          <dl key={ingredient.text} data-testid="ingredient">
            <Body3>
              <Strong>
                {ingredient.subIngredientsHTML ? `${ingredient.text}: ` : ingredient.text}
              </Strong>
              {ingredient.subIngredientsHTML && (
                <span
                  dangerouslySetInnerHTML={{ __html: sanitize(ingredient.subIngredientsHTML) }}
                />
              )}
            </Body3>
          </dl>
        ))}
      </div>
      <Allergens labelHtml={allergens?.labelHTML} disclaimerHtml={allergens?.disclaimerHTML} />
    </SectionPanel>
  )
}
